import { LinearProgress, Typography } from '@mui/material';
import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { fetchFavourites } from '../api/mobileapi';
import { FavouritesData } from '../api/types';
import { FavouritesWrapper } from '../components/Favourites/FavouritesWrapper';
import { GlobalError } from '../components/GlobalError/GlobalError';
import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { useTranslations } from '../components/Translations/TranslationsProvider';
import { AdamsError } from '../utils/errors';

export const FavouritesPage = () => {
    const { translations } = useTranslations();
    const { currentLanguage } = useHomeData();

    const {
        data: favourites,
        isLoading,
        error,
    } = useQuery<FavouritesData, AdamsError>(['favourites'], () => fetchFavourites({ language: currentLanguage }), {
        enabled: Boolean(currentLanguage),
    });
    if (error) {
        return <GlobalError error={error} translations={translations} />;
    }

    return isLoading || !translations || !favourites ? (
        <LinearProgress />
    ) : (
        <>
            <Typography variant="h5" gutterBottom>
                {translations.MY_FAVOURITES_TITLE}
            </Typography>
            <FavouritesWrapper currentLanguage={currentLanguage} favourites={favourites.accessPoints} />
        </>
    );
};
